exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-card[data-v-3c27197c] {\n  background-color: #b3c0d1;\n}\n.el-card__body[data-v-3c27197c] {\n  padding: 20px;\n}\n.el-row[data-v-3c27197c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-top: 60px;\n  margin-bottom: 60px;\n}\n.bg-purple[data-v-3c27197c] {\n  background: #d3dce6;\n}\nbody[data-v-3c27197c] {\n  background: white;\n}\n.login-wrapper[data-v-3c27197c] {\n  background: #fff;\n  width: 70%;\n  margin: 12% auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c27197c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login.vue
// module id = 7L4P
// module chunks = 1